module.exports = __webpack_public_path__ + "assets/images/icons/ageing.svg?v=6b1bd802";